<header>
  <nav class="navbar navbar-dark justify-content-center">
    <span class="navbar-brand py-2">
      <img src="assets/endelogonew.png" loading="lazy" />
    </span>
  </nav>
</header>

<app-registration></app-registration>

<footer class="footer mt-auto py-3">
  <div class="container">
    <span class="text-muted">© 2020 Ένωση Δικαστών & Εισαγγελέων | Ανάπτυξη και Φιλοξενία: LawNet S.A.</span>
  </div>
</footer>
